import { Component, computed, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { translate } from '../../../../../modules/shared/shared.global-service';
import { TableColumn } from '../../../../../modules/shared/components/kit/table/table.types';
import {
    FolderEPrescriptionSearchMedicationsModalComponent,
} from '../folder-e-prescription-search-medications-modal/folder-e-prescription-search-medications-modal.component';
import { FolderEPrescriptionMedicationEntriesModalStore } from './folder-e-prescription-medication-entries-modal.store';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import { suklMedicationRecordListFrag } from './folder-e-prescription-medication-entries-modal.query';
import {
    EPrescriptionMedicationRecordListObject,
    EPrescriptionMedicationRecordObject,
} from '@libs/types/src/services/object-type/sukl/e-prescription-medication-record.object';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { featureOn } from '../../../../../feature-flag';

@Component({
    selector: 'app-folder-e-prescription-medication-entries-modal',
    templateUrl: 'folder-e-prescription-medication-entries-modal.component.html',
    styleUrls: ['folder-e-prescription-medication-entries-modal.component.scss'],
    providers: [FolderEPrescriptionMedicationEntriesModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonsComponent,
        TableComponent,
    ],
})
export class FolderEPrescriptionMedicationEntriesModalComponent extends BaseDialogComponent {

    public readonly dialogService = inject(BaseDialogService);
    public readonly store = inject(FolderEPrescriptionMedicationEntriesModalStore);
    protected readonly folderStore = inject(FolderGlobalStore);

    protected items = signal<EPrescriptionMedicationRecordObject[]>([]);

    protected columns: TableColumn[] = [
        {
            name: 'date',
        },
        {
            name: 'atc',
        },
        {
            name: 'code',
        },
        {
            name: 'trv',
        },
        {
            name: 'name',
        },
        {
            name: 'packaging',
        },
        {
            name: 'amount',
        },
        {
            name: 'dosing',
        },
        {
            name: 'prescribedByName',
        },
        {
            name: 'prescribedByPhone',
        },
    ];

    protected folder = this.folderStore.folder;

    protected selectedMedication = signal<EPrescriptionMedicationRecordObject | null>(null);

    protected canPrescribe = computed(() => {
        const selected = this.selectedMedication();
        return !!selected && (selected.magistraliter ? featureOn.E_PRESCRIPTION_MAGISTRALITER : !!selected.code);
    });

    constructor() {
        super();
        // TODO: Prozkoumat možnosti stránkování Lékového záznamu.
        effect(() => {
            const folderId = this.folder()?.id;
            if (folderId) {
                this.store.api.suklMedicationRecords({ id: folderId }, suklMedicationRecordListFrag)
                    .then((result) => {
                        this.items.set((result as EPrescriptionMedicationRecordListObject | null)?.records ?? []);
                    });
            }
        });
    }

    prescribe() {
        const selected = this.selectedMedication();
        if (selected && this.canPrescribe()) {
            this.dialogRef.close(selected);
        }
    }

    selection(item: EPrescriptionMedicationRecordObject) {
        this.selectedMedication.set(item);
    }

    search() {
        this.dialogService.open(FolderEPrescriptionSearchMedicationsModalComponent, {
            header: translate.instant('ePrescriptions.search.title'),
            styleClass: 'p-dialog-width-80',
        });
    }
}
